import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { servicesData } from '../../data/Data';
import videoUrl from "../../assets/vdo/vdo1.mp4";

const VideoSection = () => {
    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: true
    });


    const featuredServices = servicesData.slice(0, 3);

    return (
        <section className="py-20 bg-gradient-to-b border-b border-gray-200 from-white to-bgpalecolor font-basefont" ref={ref}>
            <div className="max-w-7xl mx-auto px-6 lg:px-8 ">
                <motion.div
                    className="text-center mb-16"
                    initial={{ opacity: 0, y: 20 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.7 }}
                >
                    <motion.span
                        className="inline-block px-4 py-1 rounded-full bg-basecolor bg-opacity-10 text-basecolor font-medium text-sm mb-4"
                        whileHover={{ scale: 1.05 }}
                    >
                        DISCOVER OUR EXPERTISE
                    </motion.span>
                    <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                        Your <span className="text-basecolor">Global Business</span> Partner
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Connecting opportunities across borders with innovative solutions tailored to your international business needs.
                    </p>
                </motion.div>

                <div className="flex justify-center items-center mb-16">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                        transition={{ duration: 0.8, delay: 0.2 }}
                        className="w-full flex justify-center items-center"
                    >
                        <div className="relative w-full max-w-6xl rounded-lg overflow-hidden shadow-2xl">
                            <motion.video
                                src={videoUrl}
                                autoPlay
                                loop
                                muted
                                playsInline
                                className="w-full h-full object-cover aspect-video"
                                initial={{ opacity: 1 }}
                            />
                        </div>
                    </motion.div>
                </div>



                <motion.div
                    className="mt-20 "
                    initial={{ opacity: 0, y: 30 }}
                    animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
                    transition={{ duration: 0.7, delay: 0.4 }}
                >
                    <h3 className="text-3xl font-bold text-center mb-12">Our Featured Services</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {featuredServices?.map((service, index) => (
                            <motion.div
                                key={service.id}
                                className="bg-white rounded-xl shadow-lg border border-gray-200 p-6 hover:shadow-xl transition-shadow overflow:visible -z-10"
                                whileHover={{ y: -5 }}
                                initial={{ opacity: 0, y: 20 }}
                                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                                transition={{ duration: 0.5, delay: 0.2 + (index * 0.1) }}
                            >
                                <div className="text-basecolor mb-4">
                                    {service.icon}
                                </div>
                                <h4 className="text-xl font-bold mb-2">{service.title}</h4>
                                <p className="text-gray-600 mb-4">{service.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                <motion.div
                    className="mt-16 text-center"
                    initial={{ opacity: 0 }}
                    animate={inView ? { opacity: 1 } : { opacity: 0 }}
                    transition={{ duration: 0.7, delay: 0.6 }}
                >
                    <motion.a
                        href="/contact"
                        className="inline-block px-8 py-4 bg-basecolor text-white font-medium rounded-full shadow-lg hover:bg-opacity-90 transition-all"
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        Start Your Global Journey Today
                    </motion.a>
                </motion.div>
            </div>
        </section>
    );
};

export default VideoSection;
